var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVerticalLines(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1393,
    height: 546,
    viewBox: "0 0 1393 546",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M43.5 0.5V546",
    stroke: "url(#paint0_linear_650_205)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1 0.5V546",
    stroke: "url(#paint1_linear_650_205)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M87 0.5V546",
    stroke: "url(#paint2_linear_650_205)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.5 0.5V546",
    stroke: "url(#paint3_linear_650_205)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174 0.5V546",
    stroke: "url(#paint4_linear_650_205)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.5 0.5V546",
    stroke: "url(#paint5_linear_650_205)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261 0.5V546",
    stroke: "url(#paint6_linear_650_205)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.5 0.5V546",
    stroke: "url(#paint7_linear_650_205)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348 0.5V546",
    stroke: "url(#paint8_linear_650_205)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.5 0.5V546",
    stroke: "url(#paint9_linear_650_205)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435 0.5V546",
    stroke: "url(#paint10_linear_650_205)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M478.5 0.5V546",
    stroke: "url(#paint11_linear_650_205)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M522 0.5V546",
    stroke: "url(#paint12_linear_650_205)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M565.5 0.5V546",
    stroke: "url(#paint13_linear_650_205)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M609 0.5V546",
    stroke: "url(#paint14_linear_650_205)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M652.5 0.5V546",
    stroke: "url(#paint15_linear_650_205)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M696 0.5V546",
    stroke: "url(#paint16_linear_650_205)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M739.5 0.5V546",
    stroke: "url(#paint17_linear_650_205)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M783 0.5V546",
    stroke: "url(#paint18_linear_650_205)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M826.5 0.5V546",
    stroke: "url(#paint19_linear_650_205)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M870 0.5V546",
    stroke: "url(#paint20_linear_650_205)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M913.5 0.5V546",
    stroke: "url(#paint21_linear_650_205)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M957 0.5V546",
    stroke: "url(#paint22_linear_650_205)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1000.5 0.5V546",
    stroke: "url(#paint23_linear_650_205)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1044 0.5V546",
    stroke: "url(#paint24_linear_650_205)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1087.5 0.5V546",
    stroke: "url(#paint25_linear_650_205)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1131 0.5V546",
    stroke: "url(#paint26_linear_650_205)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1174.5 0.5V546",
    stroke: "url(#paint27_linear_650_205)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1218 0.5V546",
    stroke: "url(#paint28_linear_650_205)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M1261.5 0.5V546",
    stroke: "url(#paint29_linear_650_205)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M1305 0.5V546",
    stroke: "url(#paint30_linear_650_205)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M1348.5 0.5V546",
    stroke: "url(#paint31_linear_650_205)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M1392 0.5V546",
    stroke: "url(#paint32_linear_650_205)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_650_205",
    x1: 44,
    y1: 0.5,
    x2: 44,
    y2: 546,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E05A32",
    stopOpacity: 0.5
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_650_205",
    x1: 1.5,
    y1: 0.5,
    x2: 1.5,
    y2: 546,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E05A32",
    stopOpacity: 0.5
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_650_205",
    x1: 87.5,
    y1: 0.5,
    x2: 87.5,
    y2: 546,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E05A32",
    stopOpacity: 0.5
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_650_205",
    x1: 131,
    y1: 0.5,
    x2: 131,
    y2: 546,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E05A32",
    stopOpacity: 0.5
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_650_205",
    x1: 174.5,
    y1: 0.5,
    x2: 174.5,
    y2: 546,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E05A32",
    stopOpacity: 0.5
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_650_205",
    x1: 218,
    y1: 0.5,
    x2: 218,
    y2: 546,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E05A32",
    stopOpacity: 0.5
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_650_205",
    x1: 261.5,
    y1: 0.5,
    x2: 261.5,
    y2: 546,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E05A32",
    stopOpacity: 0.5
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_650_205",
    x1: 305,
    y1: 0.5,
    x2: 305,
    y2: 546,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E05A32",
    stopOpacity: 0.5
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_650_205",
    x1: 348.5,
    y1: 0.5,
    x2: 348.5,
    y2: 546,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E05A32",
    stopOpacity: 0.5
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_650_205",
    x1: 392,
    y1: 0.5,
    x2: 392,
    y2: 546,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E05A32",
    stopOpacity: 0.5
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_650_205",
    x1: 435.5,
    y1: 0.5,
    x2: 435.5,
    y2: 546,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E05A32",
    stopOpacity: 0.5
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_650_205",
    x1: 479,
    y1: 0.5,
    x2: 479,
    y2: 546,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E05A32",
    stopOpacity: 0.5
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_650_205",
    x1: 522.5,
    y1: 0.5,
    x2: 522.5,
    y2: 546,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E05A32",
    stopOpacity: 0.5
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_650_205",
    x1: 566,
    y1: 0.5,
    x2: 566,
    y2: 546,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E05A32",
    stopOpacity: 0.5
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_650_205",
    x1: 609.5,
    y1: 0.5,
    x2: 609.5,
    y2: 546,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E05A32",
    stopOpacity: 0.5
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_650_205",
    x1: 653,
    y1: 0.5,
    x2: 653,
    y2: 546,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E05A32",
    stopOpacity: 0.5
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_650_205",
    x1: 696.5,
    y1: 0.5,
    x2: 696.5,
    y2: 546,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E05A32",
    stopOpacity: 0.5
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_650_205",
    x1: 740,
    y1: 0.5,
    x2: 740,
    y2: 546,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E05A32",
    stopOpacity: 0.5
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_650_205",
    x1: 783.5,
    y1: 0.5,
    x2: 783.5,
    y2: 546,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E05A32",
    stopOpacity: 0.5
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_650_205",
    x1: 827,
    y1: 0.5,
    x2: 827,
    y2: 546,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E05A32",
    stopOpacity: 0.5
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_650_205",
    x1: 870.5,
    y1: 0.5,
    x2: 870.5,
    y2: 546,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E05A32",
    stopOpacity: 0.5
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_650_205",
    x1: 914,
    y1: 0.5,
    x2: 914,
    y2: 546,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E05A32",
    stopOpacity: 0.5
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_650_205",
    x1: 957.5,
    y1: 0.5,
    x2: 957.5,
    y2: 546,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E05A32",
    stopOpacity: 0.5
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_650_205",
    x1: 1001,
    y1: 0.5,
    x2: 1001,
    y2: 546,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E05A32",
    stopOpacity: 0.5
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_650_205",
    x1: 1044.5,
    y1: 0.5,
    x2: 1044.5,
    y2: 546,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E05A32",
    stopOpacity: 0.5
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_650_205",
    x1: 1088,
    y1: 0.5,
    x2: 1088,
    y2: 546,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E05A32",
    stopOpacity: 0.5
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_650_205",
    x1: 1131.5,
    y1: 0.5,
    x2: 1131.5,
    y2: 546,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E05A32",
    stopOpacity: 0.5
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_650_205",
    x1: 1175,
    y1: 0.5,
    x2: 1175,
    y2: 546,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E05A32",
    stopOpacity: 0.5
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_650_205",
    x1: 1218.5,
    y1: 0.5,
    x2: 1218.5,
    y2: 546,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E05A32",
    stopOpacity: 0.5
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_650_205",
    x1: 1262,
    y1: 0.5,
    x2: 1262,
    y2: 546,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E05A32",
    stopOpacity: 0.5
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_650_205",
    x1: 1305.5,
    y1: 0.5,
    x2: 1305.5,
    y2: 546,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E05A32",
    stopOpacity: 0.5
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_650_205",
    x1: 1349,
    y1: 0.5,
    x2: 1349,
    y2: 546,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E05A32",
    stopOpacity: 0.5
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_650_205",
    x1: 1392.5,
    y1: 0.5,
    x2: 1392.5,
    y2: 546,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E05A32",
    stopOpacity: 0.5
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerticalLines);
export default __webpack_public_path__ + "static/media/VerticalLines.cc57c05424de554b93cd1465f15fd705.svg";
export { ForwardRef as ReactComponent };